import React, { useState, useEffect } from "react";
import { database } from "../../firebase";
import { ref, query, orderByChild, limitToLast, onValue, set, runTransaction } from "firebase/database";
import { getFirestore, collection, addDoc, updateDoc, orderBy, getDocs, limit, setDoc, doc } from "firebase/firestore";
import { invalidateCuadrillasCache } from "../../services/cuadrillasService";
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import CircularProgress from '@mui/material/CircularProgress';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Grid from '@mui/material/Grid';

function AddCuadrilla() {
    const currentUser = JSON.parse(localStorage.getItem("currentUser"));
    const isAdmin = currentUser?.rol === 'admin';
    
    const [state, setState] = useState({
        lastId: -2,
        numero: '',
        codigo: '',
        usuario: '',
        nroTelefono: '',
        correoElectronico: '',
        chapaMovil: '',
        aseguradora: '',
        porcentajeParticipacion: '',
        submitted: false,
        spinner: false,
    });

    // useEffect(() => {
    //     const topUserPostsRef = query(ref(database, 'cuadrillas'), orderByChild('id'), limitToLast(1));
    //     onValue(topUserPostsRef, (snapshot) => {
    //         const key = snapshot.val() ? Object.keys(snapshot.val()) : -2;
    //         setState(prevState => ({ ...prevState, lastId: parseInt(key, 10) }));
    //     }, {
    //         onlyOnce: true
    //     });
    // }, [state.lastId]);

    const onChangeValues = (e) => {
        const name = e.target.name;
        const value = e.target.value;
        setState(prevState => ({ ...prevState, [name]: value }));
    };

    const saveCuadrillaFirestore = async () => {
        const firestore = getFirestore();

        try {
            setState(prevState => ({ ...prevState, spinner: true }));
            // Referencia a la colección de Firestore
            const cuadrillasCollectionRef = collection(firestore, "cuadrillas");

            // Consulta para obtener el documento con el ID más alto
            const q = query(cuadrillasCollectionRef, orderBy("id", "desc"), limit(1));
            const querySnapshot = await getDocs(q);

            let lastId = 0;

            // Si existe al menos un documento, obtener el último ID
            if (!querySnapshot.empty) {
                querySnapshot.forEach((doc) => {
                    lastId = doc.data().id;
                });
            }

            // Generar el nuevo ID sumando 1 al último ID
            const newId = lastId + 1;

            // Nuevo registro con el nuevo ID (activa: true por defecto)
            const newCuadrillaData = {
                numero: state.numero,
                codigo: state.codigo,
                usuario: state.usuario,
                nroTelefono: state.nroTelefono,
                correoElectronico: state.correoElectronico,
                chapaMovil: state.chapaMovil,
                aseguradora: state.aseguradora,
                porcentajeParticipacion: state.porcentajeParticipacion,
                id: newId,
                activa: true
            };

            // Guardar el nuevo documento en Firestore con el nuevo ID
            await setDoc(doc(firestore, "cuadrillas", newId.toString()), newCuadrillaData);
            invalidateCuadrillasCache();
            setState(
                prevState => ({
                    ...prevState,
                    submitted: true,
                    spinner: false
                }));

            console.log("Nuevo documento guardado con éxito");
        } catch (error) {
            console.error("Error al guardar el nuevo documento: ", error);
        }
    };

    const saveCuadrilla = () => {
        let lastId = state.lastId;

        const topUserPostsRef = query(ref(database, 'cuadrillas'), orderByChild('id'), limitToLast(1));
        onValue(topUserPostsRef, (snapshot) => {
            const key = snapshot.val() ? Object.keys(snapshot.val()) : -2;
            lastId = parseInt(key, 10);
            setState(prevState => ({ ...prevState, spinner: true }));
        }, {
            onlyOnce: true
        });

        setTimeout(() => {
            let data = {
                id: lastId + 1,
                numero: state.numero,
                codigo: state.codigo,
            };
            set(ref(database, 'cuadrillas/' + data.id), data)
                .then(() => {
                    setState(
                        prevState => ({
                            ...prevState,
                            submitted: true,
                            spinner: false
                        }));
                })
                .catch((e) => {
                    console.log(e);
                });
        }, 1500);
    }

    const newProduct = () => {
        setState({
            numero: '',
            codigo: '',
            usuario: '',
            nroTelefono: '',
            correoElectronico: '',
            chapaMovil: '',
            aseguradora: '',
            porcentajeParticipacion: '',
            submitted: false,
        });
    }

    return (
        <Container component="main" maxWidth="md">
            {state.submitted ? (
                <div>
                    <Typography variant="h4">Cuadrilla creada correctamente!</Typography>
                    {/* <Button variant="contained" onClick={newProduct}>Nuevo</Button> */}
                    <Button href="/cuadrillas">
                        Ir a listado
                    </Button>
                </div>
            ) : (
                <div className="form-container">
                    {state.spinner ? (
                        <CircularProgress />
                    ) : (
                        <>
                            <Typography component="h1" variant="h5">
                                Nueva Cuadrilla
                            </Typography>
                            <div className="order-container">
                                <Grid container spacing={2}>
                                    <Grid item xs={12} sm={6}>
                                        <TextField
                                            variant="outlined"
                                            required
                                            fullWidth
                                            className="default__textfield"
                                            id="numero"
                                            label="Numero / Nombre"
                                            value={state.numero}
                                            name="numero"
                                            onChange={onChangeValues}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <TextField
                                            variant="outlined"
                                            required
                                            fullWidth
                                            className="default__textfield"
                                            id="codigo"
                                            label="Código"
                                            value={state.codigo}
                                            name="codigo"
                                            onChange={onChangeValues}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <TextField
                                            variant="outlined"
                                            fullWidth
                                            className="default__textfield"
                                            id="usuario"
                                            label="Usuario"
                                            value={state.usuario}
                                            name="usuario"
                                            onChange={onChangeValues}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <TextField
                                            variant="outlined"
                                            fullWidth
                                            type="number"
                                            className="default__textfield"
                                            id="nroTelefono"
                                            label="Nro. de Teléfono"
                                            value={state.nroTelefono}
                                            name="nroTelefono"
                                            onChange={onChangeValues}
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <TextField
                                            variant="outlined"
                                            fullWidth
                                            type="email"
                                            className="default__textfield"
                                            id="correoElectronico"
                                            label="Correo Electrónico"
                                            value={state.correoElectronico}
                                            name="correoElectronico"
                                            onChange={onChangeValues}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <TextField
                                            variant="outlined"
                                            fullWidth
                                            className="default__textfield"
                                            id="chapaMovil"
                                            label="Chapa Móvil"
                                            value={state.chapaMovil}
                                            name="chapaMovil"
                                            onChange={onChangeValues}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <TextField
                                            variant="outlined"
                                            fullWidth
                                            className="default__textfield"
                                            id="aseguradora"
                                            label="Aseguradora"
                                            value={state.aseguradora}
                                            name="aseguradora"
                                            onChange={onChangeValues}
                                        />
                                    </Grid>
                                    {isAdmin && (
                                        <Grid item xs={12} sm={6}>
                                            <TextField
                                                variant="outlined"
                                                fullWidth
                                                type="number"
                                                className="default__textfield"
                                                id="porcentajeParticipacion"
                                                label="% Participación"
                                                value={state.porcentajeParticipacion}
                                                name="porcentajeParticipacion"
                                                onChange={onChangeValues}
                                                inputProps={{
                                                    min: 0,
                                                    max: 100,
                                                    step: 0.01
                                                }}
                                            />
                                        </Grid>
                                    )}
                                </Grid>
                                <Button
                                    type="button"
                                    fullWidth
                                    variant="contained"
                                    color="primary"
                                    className="button__save"
                                    onClick={saveCuadrillaFirestore}
                                >
                                    Aceptar
                                </Button>
                            </div>
                        </>
                    )}
                </div>
            )}
        </Container>
    );
}

export default AddCuadrilla;
